import * as url from "../../helpers/url_helper";
import { apiCall } from "./apiService";

/**
 * Updates usage charges (variable and fixed) for a store
 * @param {string} storeDomain - Store domain
 * @param {number} variableCharge - Variable charge percentage
 * @param {number} fixedCharge - Fixed charge in dollars
 * @param {Function} notifyError - Error notification function
 * @returns {Promise<Object|null>} Response data or null if error
 */
export const updateStoreUsageCharges = async (storeDomain, variableCharge, fixedCharge, notifyError) => {
    return await apiCall(
        url.PUT_UPDATE_STORE,
        'PUT',
        {
            store_domain: storeDomain,
            variable_charge: Number(variableCharge),
            fixed_charge: Number(fixedCharge),
        },
        notifyError,
        "Failed to update usage charges"
    );
};

